import React from 'react';
import logo from './logo.svg';
import './SidebarLogo.css';
import { useIwaContext } from '@cognitranlimited/itis-web';
export var SidebarLogo = function () {
    var strings = useIwaContext().strings;
    return React.createElement("img", { className: "SidebarLogo", src: logo, alt: strings.app.name });
};
